import { render, staticRenderFns } from "./specification.vue?vue&type=template&id=260b1c48&"
import script from "./specification.vue?vue&type=script&lang=js&"
export * from "./specification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports